module.exports = __webpack_public_path__ + "static/media/gl.86f56559.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gl.svg
// module id = 830
// module chunks = 0